import { injectable, interfaces } from 'inversify';
import { action, makeObservable, observable } from 'mobx';
import { ReviewMode } from './models/reviewMode';

export interface IAnnotationReviewStore {
  readonly currentMode: ReviewMode;
  setCurrentMode(mode: ReviewMode): void;
}

export namespace IAnnotationReviewStore {
  export const $: interfaces.ServiceIdentifier<IAnnotationReviewStore> = Symbol('ANNOTATION_REVIEW_STORE');
}

@injectable()
export class AnnotationReviewStore implements IAnnotationReviewStore {
  currentMode: ReviewMode = ReviewMode.Review;

  constructor() {
    makeObservable(this, {
      currentMode: observable,
      setCurrentMode: action,
    });
  }

  setCurrentMode(mode: ReviewMode): void {
    this.currentMode = mode;
  }
}
